import { HttpClient } from '@angular/common/http';
import { Defect, DefectEntityType, DefectMetadata, ItemDeletedResponse } from '@jms/model';
import { catchError, map, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DefectService {

    public defectAPI = 'api/defects/';

    constructor(private http: HttpClient) { }


    public getDefects(metadata: DefectMetadata): Observable<Defect[]> {

        let entityId = null;

        switch (metadata.type) {
            case DefectEntityType.Job: {
                entityId = metadata.job?._id;
                break;
            }
            case DefectEntityType.WorkOrder: {
                entityId = metadata.workOrder?._id;
                break;
            }
            case DefectEntityType.Code: {
                entityId = metadata.code?._id;
                break;
            }
        }

        return this.http
            .get<Defect[]>(`${this.defectAPI}${entityId}/${metadata.type}`)
            .pipe(
                map(x => x),
                catchError((error) => {
                    return of([]);
                })
            );


    }

    public getById(defectId: string): Observable<Defect> {

        return this.http
            .get<Defect>(`${this.defectAPI}${defectId}`)
            .pipe(
                map(x => x),
                catchError((error) => {
                    return of(null);
                })
            );


    }


    public onSave(defect: Defect): Observable<any> {

        return this.http
            .post(this.defectAPI, defect)
            .pipe(
                map(x => x),
                catchError((error) => {
                    return of(null);
                })
            );

    }

    public onDelete(defectId: string): Observable<ItemDeletedResponse> {

        return this.http
            .delete<ItemDeletedResponse>(`${this.defectAPI}${defectId}`)
            .pipe(
                map(x => x),
                catchError((error) => {
                    return of(null);
                })
            );

    }


}